import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AuthGuard } from './authentication/auth.guard';
import { AuthenticationService } from './authentication/authentication.service';
import { CanDeactivateGuard } from './deactivation/can-deactivate.guard';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
  ],
  providers: [
    AuthGuard,
    AuthenticationService,
    CanDeactivateGuard
  ],
  declarations: []
})
export class CoreModule { }
